export default "__VITE_ASSET__p$Ex1_v1__"